import React, { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { useReactToPrint } from 'react-to-print'
import { getDanfe } from 'src/components/Danfe/danfeApi'
import { InvoiceTypes } from 'src/components/Danfe/danfeTypes'
import { actions as appActions } from 'src/features/state'
import { getErrorMessage } from 'src/utils/getErrorMessage'
import * as S from './styles'

const SECOND_REASON_MAX_LENGTH = 40

const buildReasons = (messages) => {
  const uniqueMessages = [...new Set(messages)]

  if (uniqueMessages.length === 1) {
    return uniqueMessages[0]
  }

  const [first, second] = uniqueMessages

  return `${first}; ${second.slice(0, SECOND_REASON_MAX_LENGTH)}...`
}

const buildFailureMessage = ({ receivementId, failedMessages, total }) => {
  const prefix = receivementId ? `Recebimento ${receivementId}: ` : ''
  const summary = total === 1
    ? 'nota falhou'
    : `${failedMessages.length}/${total} notas falharam`

  return `${prefix}${summary}: ${buildReasons(failedMessages)}`
}

export const InvoicePrint = ({ invoiceKeys, receivementId }) => {
  const [invoicesHtml, setInvoicesHtml] = useState([])
  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()

  const printAreaRef = useRef(null)

  const print = useReactToPrint({
    content: () => printAreaRef.current,
    copyStyles: false,
  })

  const printInvoices = async (e) => {
    e.preventDefault()

    if (loading) {
      return
    }

    if (invoiceKeys.length === 0) {
      toast.error('Fornecimento não possui notas fiscais')
      return
    }

    setInvoicesHtml([])
    setLoading(true)
    dispatch(appActions.isLoading(true))

    try {
      const results = await Promise.all(
        invoiceKeys.map((invoiceKey) => getDanfe({
          invoiceKey,
          type: InvoiceTypes.RECEIVEMENT,
        })),
      )

      const _invoicesHtml = []
      const failedMessages = []

      results.forEach((result) => {
        if (result.isOk) {
          _invoicesHtml.push(result.data)
          return
        }

        failedMessages.push(getErrorMessage(result, 'Falha ao carregar a nota fiscal'))
      })

      if (failedMessages.length > 0) {
        const message = buildFailureMessage({
          receivementId,
          failedMessages,
          total: invoiceKeys.length,
        })
        const notify = _invoicesHtml.length === 0 ? toast.error : toast.warning

        notify(message, { style: { overflowWrap: 'anywhere' } })
      }

      if (_invoicesHtml.length === 0) {
        return
      }

      setInvoicesHtml(_invoicesHtml)
      print()
    } finally {
      setLoading(false)
      dispatch(appActions.isLoading(false))
    }
  }

  return (
    <S.IconWrapper>
      <S.PrintInvoiceIcon
        aria-label="imprimir-nota-fiscal"
        onClick={printInvoices}
      />
      <S.PrintArea ref={printAreaRef}>
        {invoicesHtml.map((invoiceHtml, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            style={{ pageBreakBefore: 'always' }}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: invoiceHtml }}
          />
        ))}
      </S.PrintArea>
    </S.IconWrapper>
  )
}
